import React from "react";
import { Container, Row, Card } from "reactstrap";
import Header from "components/Headers/Header";
import SuperAdminDashboard from "./pages/SuperAdmin";
// import { useGetLogedInUser } from "utils/auth.api";
import AdminDashboard from "./pages/Admin";
import TeacherDashboard from "./pages/Teacher";
import StudentDashboard from "./pages/Student";

const Dashboard = () => {
  const role = localStorage.getItem("role");
  ;
  return (
    <>
      <Header />
      <Container style={{ marginTop: "-160px" }} fluid>
        <Row>
          <div className="col">
            <Card className="shadow py-4">
              {role === "superadmin" && <SuperAdminDashboard />}
              {role === "admin" && <AdminDashboard />}
              {role === "teacher" && <TeacherDashboard />}
              {role === "student" && <StudentDashboard />}
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Dashboard;
